import { m } from 'framer-motion';
// @mui
import Container from '@mui/material/Container';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Unstable_Grid2';
// hooks
// utils
// components
import { MotionViewport, varFade } from 'src/components/animate';
import Image from 'src/components/image';
import { useLocales } from 'src/locales';

// ----------------------------------------------------------------------

export const SKILLS = [...Array(3)].map((_, index) => ({
  label: ['Partners', 'Customer', 'Booking'][index],
  value: [55, 40, 20][index],
}));

// ----------------------------------------------------------------------

export default function AboutWhat({ data }) {
  const theme = useTheme();


  const isLight = theme.palette.mode === 'light';

  const { currentLang } = useLocales();



  return (
    <Container
      component={MotionViewport}
      sx={{
        py: { xs: 2, md: 8 },
        textAlign: { xs: 'center', md: 'unset' },
      }}
    >
      <Grid
        sx={{ direction: 'ltr' }}
        flexDirection={
          currentLang?.label === 'Arabic' || currentLang?.label === 'Urdu' ? 'row-reverse' : 'row'
        }
        container
        alignItems="flex-start"
      >
        {/* <Grid
          container
          xs={11}
          md={6}
          lg={7}
          alignItems="center"
          sx={{
            p: { md: 3 },
            display: {
              lg: 'block',
              md: 'block',
              sm: 'none',
              xs: 'none',
            },
          }}
        >
          <Grid xs={11}>
            <m.div variants={varFade().inUp}>
              <Image alt="our office 2" src={`${data?.image}`} ratio="1/1" sx={{ borderRadius: 3 }} />
            </m.div>
          </Grid>
        </Grid> */}

        <Grid xs={12} md={12} lg={12} >
          <m.div variants={varFade().inRight}>
            <Typography whiteSpace={'nowrap'} variant="h2" component="h2" sx={{ mb: 0 }}>
              {data.title}
            </Typography>
          </m.div>

          <m.div variants={varFade().inRight}>
            <Typography
              sx={{
                color: theme.palette.mode === 'light' ? 'text.secondary' : 'common.white',
              }}
            >
              <div
                style={{ direction: 'ltr' }}
                dangerouslySetInnerHTML={{
                  __html: data?.content ? `${data?.content}` : `${'No Data Found'}`,
                }}
              />
            </Typography>
          </m.div>
        </Grid>
      </Grid>
    </Container>
    // </Box>
  );
}
